// extracted by mini-css-extract-plugin
module.exports = {"background_box":"paythank_background_box__1sPU6","thankyou_box":"paythank_thankyou_box__3rvg6","payment_done":"paythank_payment_done__23l3e"};